var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertsAndManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 89,
    viewBox: "0 0 293 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2633_211438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.333 4.99549C199.333 2.23656 201.57 0 204.329 0H234.634C237.393 0 239.63 2.23656 239.63 4.99549V36.4358C239.63 39.1947 237.393 41.4313 234.634 41.4313H204.329C201.57 41.4313 199.333 39.1947 199.333 36.4358V4.99549Z",
    fill: "#D9915D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.387 12.9261C222.998 13.3659 224.91 15.626 224.907 18.273V22.6607C224.907 23.4916 225.08 24.314 225.415 25.085L225.548 25.3707L225.995 26.2648C226.102 26.4772 226.016 26.7355 225.803 26.8418C225.743 26.8717 225.677 26.8873 225.611 26.8873H213.352C213.114 26.8873 212.922 26.6947 212.922 26.4572C212.922 26.3903 212.937 26.3244 212.967 26.2645L213.415 25.3707C213.835 24.5282 214.054 23.6005 214.054 22.6598V18.2721C214.045 15.6223 215.962 13.3576 218.578 12.9261C219.176 12.8221 219.789 12.8221 220.387 12.9261ZM220.174 14.1464C219.717 14.0669 219.248 14.0669 218.78 14.1483C216.82 14.4714 215.37 16.1278 215.295 18.0977L215.292 18.2723V22.66C215.292 23.6031 215.109 24.5359 214.755 25.4092L214.652 25.6489H224.311L224.279 25.5788C223.916 24.7446 223.712 23.8589 223.675 22.9607L223.669 22.6609V18.2718C223.671 16.289 222.28 14.5869 220.352 14.1801L220.174 14.1464ZM219.481 28.6577C218.787 28.6577 218.223 28.0945 218.223 27.3997H220.739C220.739 28.0945 220.176 28.6577 219.481 28.6577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.037 4.99549C250.037 2.23656 252.273 0 255.032 0H285.338C288.097 0 290.333 2.23656 290.333 4.99549V36.0045C290.333 38.7634 288.097 41 285.338 41H255.032C252.273 41 250.037 38.7634 250.037 36.0045V4.99549Z",
    fill: "#4DD3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.155 15.4004C271.016 15.4004 270.88 15.4436 270.765 15.5244C270.65 15.6052 270.561 15.72 270.509 15.854C270.456 15.9881 270.444 16.1353 270.472 16.2769C270.501 16.4185 270.569 16.548 270.668 16.6489L273.664 19.771H267.765C267.672 19.7696 267.581 19.7874 267.495 19.8234C267.409 19.8593 267.331 19.9127 267.265 19.9803C267.199 20.048 267.147 20.1286 267.111 20.2175C267.076 20.3064 267.057 20.4019 267.057 20.4982C267.057 20.5946 267.076 20.69 267.111 20.7789C267.147 20.8679 267.199 20.9485 267.265 21.0162C267.331 21.0838 267.409 21.1372 267.495 21.1731C267.581 21.209 267.672 21.2268 267.765 21.2255H273.664L270.668 24.3475C270.601 24.4146 270.548 24.4948 270.511 24.5836C270.474 24.6725 270.455 24.768 270.454 24.8648C270.453 24.9616 270.47 25.0575 270.506 25.1471C270.541 25.2367 270.593 25.3181 270.658 25.3865C270.724 25.4549 270.802 25.509 270.888 25.5456C270.974 25.5821 271.066 25.6005 271.159 25.5995C271.252 25.5985 271.343 25.5782 271.429 25.5398C271.514 25.5014 271.591 25.4457 271.655 25.3759L275.78 21.0763C275.866 21.0084 275.935 20.9207 275.983 20.8203C276.03 20.7198 276.055 20.6092 276.055 20.4972C276.055 20.3851 276.03 20.2746 275.982 20.1743C275.934 20.0739 275.865 19.9865 275.779 19.9187L271.655 15.6206C271.59 15.5509 271.512 15.4955 271.426 15.4577C271.34 15.4199 271.248 15.4004 271.155 15.4004ZM262.183 19.771C261.998 19.771 261.82 19.8476 261.689 19.984C261.558 20.1204 261.485 20.3054 261.485 20.4982C261.485 20.6911 261.558 20.8761 261.689 21.0125C261.82 21.1489 261.998 21.2255 262.183 21.2255C262.368 21.2255 262.545 21.1489 262.676 21.0125C262.807 20.8761 262.88 20.6911 262.88 20.4982C262.88 20.3054 262.807 20.1204 262.676 19.984C262.545 19.8476 262.368 19.771 262.183 19.771ZM264.974 19.771C264.789 19.771 264.611 19.8476 264.48 19.984C264.35 20.1204 264.276 20.3054 264.276 20.4982C264.276 20.6911 264.35 20.8761 264.48 21.0125C264.611 21.1489 264.789 21.2255 264.974 21.2255C265.159 21.2255 265.336 21.1489 265.467 21.0125C265.598 20.8761 265.672 20.6911 265.672 20.4982C265.672 20.3054 265.598 20.1204 265.467 19.984C265.336 19.8476 265.159 19.771 264.974 19.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.333 53.5643C199.333 50.8054 201.57 48.5688 204.329 48.5688H234.634C237.393 48.5688 239.63 50.8054 239.63 53.5643V83.5733C239.63 86.3323 237.393 88.5688 234.634 88.5688H204.329C201.57 88.5688 199.333 86.3323 199.333 83.5734V53.5643Z",
    fill: "#8780DA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2633_211438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.133 60.719C218.08 60.7061 218.026 60.7 217.971 60.7007C213.68 60.7007 210.187 64.1938 210.187 68.4853C210.187 72.7769 213.68 76.2699 217.971 76.2699C218.026 76.2707 218.08 76.2645 218.133 76.2517C218.186 76.2645 218.241 76.2707 218.296 76.2699C222.587 76.2699 226.08 72.7769 226.08 68.4853C226.08 64.1938 222.587 60.7007 218.296 60.7007C218.241 60.7 218.186 60.7061 218.133 60.719ZM218.133 61.9799C218.08 61.9928 218.026 61.999 217.971 61.9982C214.381 61.9982 211.484 64.895 211.484 68.4853C211.484 72.0757 214.381 74.9725 217.971 74.9725C218.026 74.9717 218.08 74.9779 218.133 74.9907C218.186 74.9779 218.241 74.9717 218.296 74.9725C221.886 74.9725 224.783 72.0757 224.783 68.4853C224.783 64.895 221.886 61.9982 218.296 61.9982C218.241 61.999 218.186 61.9928 218.133 61.9799ZM220.918 66.0805C221.036 65.9596 221.196 65.8892 221.364 65.8841C221.495 65.8803 221.624 65.916 221.734 65.9866C221.844 66.0572 221.93 66.1594 221.981 66.2798C222.032 66.4002 222.045 66.5331 222.019 66.6613C221.993 66.7894 221.929 66.9067 221.836 66.9979L217.295 71.5389C217.173 71.6605 217.008 71.7288 216.836 71.7288C216.664 71.7288 216.499 71.6605 216.377 71.5389L214.431 69.5927C214.369 69.5329 214.319 69.4613 214.285 69.3821C214.251 69.3029 214.233 69.2176 214.232 69.1313C214.231 69.045 214.247 68.9594 214.28 68.8795C214.312 68.7996 214.361 68.727 214.422 68.666C214.483 68.6049 214.555 68.5567 214.635 68.5241C214.715 68.4914 214.801 68.4751 214.887 68.476C214.973 68.4768 215.059 68.4949 215.138 68.5292C215.217 68.5634 215.289 68.6131 215.348 68.6754L216.836 70.1629L220.918 66.0805Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.037 53.5643C250.037 50.8054 252.273 48.5688 255.032 48.5688H285.338C288.097 48.5688 290.333 50.8054 290.333 53.5643V85.0046C290.333 87.7636 288.097 90.0001 285.338 90.0001H255.032C252.273 90.0001 250.037 87.7636 250.037 85.0046V53.5643Z",
    fill: "#BAB3E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.613 62.3638H266.802H266.052C266.023 62.3638 265.995 62.3657 265.967 62.3695C265.762 62.378 265.566 62.488 265.456 62.6787L265.081 63.3288L264.088 65.049L263.755 65.6254C263.732 65.6591 263.712 65.6947 263.694 65.7321C263.651 65.8187 263.63 65.9111 263.629 66.0027C263.629 66.0135 263.628 66.0245 263.628 66.0355V75.6664C263.628 76.0687 263.955 76.3949 264.357 76.3949H276.013C276.415 76.3949 276.742 76.0687 276.742 75.6664V66.0355C276.742 65.8742 276.689 65.7252 276.6 65.6045L276.28 65.049L275.287 63.3288L274.911 62.6787C274.844 62.562 274.744 62.4756 274.63 62.4241C274.549 62.3854 274.459 62.3638 274.363 62.3638H273.613ZM266.153 63.948L266.353 63.6022H266.802H273.613H274.014L274.214 63.948L274.999 65.307H265.369L266.153 63.948ZM264.867 66.5446H275.503V75.1563H264.867V66.5446ZM268.255 68.5563C267.913 68.5563 267.635 68.8335 267.635 69.1755C267.635 69.5175 267.913 69.7948 268.255 69.7948H272.116C272.458 69.7948 272.735 69.5175 272.735 69.1755C272.735 68.8335 272.458 68.5563 272.116 68.5563H268.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2633_211438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.534424 1.39131C0.534424 0.62291 1.15734 0 1.92574 0H19.1431C19.9115 0 20.5344 0.622913 20.5344 1.39132V90.324H0.534424V1.39131Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.534424 30.9885C0.534424 30.2201 1.15734 29.5972 1.92574 29.5972H19.1431C19.9115 29.5972 20.5344 30.2201 20.5344 30.9885V90.4356H0.534424V30.9885Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.534424,
    y: 42.7515,
    width: 20,
    height: 47.6842,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5344 1.39131C27.5344 0.62291 28.1573 0 28.9257 0H46.1431C46.9115 0 47.5344 0.622913 47.5344 1.39132V90.324H27.5344V1.39131Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5344 53.1862C27.5344 52.4178 28.1573 51.7949 28.9257 51.7949H46.1431C46.9115 51.7949 47.5344 52.4178 47.5344 53.1862V90.4355H27.5344V53.1862Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5344,
    y: 68.1743,
    width: 20,
    height: 13.2175,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5344 81.4028H47.5344V90.4352H27.5344V81.4028Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5347 2.78263C54.5347 1.24583 55.7805 0 57.3173 0H71.752C73.2888 0 74.5347 1.24583 74.5347 2.78263V90.324H54.5347V2.78263Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5347 0H74.5347V90.4355H54.5347V0Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5347,
    y: 32.6958,
    width: 20,
    height: 57.7396,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5347 81.4028H74.5347V90.4352H54.5347V81.4028Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5347 1.39131C81.5347 0.62291 82.1576 0 82.926 0H100.143C100.912 0 101.535 0.622913 101.535 1.39132V90.324H81.5347V1.39131Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5347 35.0993C81.5347 34.3309 82.1576 33.708 82.926 33.708H100.143C100.912 33.708 101.535 34.3309 101.535 35.0993V90.4357H81.5347V35.0993Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5347,
    y: 49.3286,
    width: 20,
    height: 32.0635,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5347 64.127H101.535V90.4355H81.5347V64.127Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.535 1.39131C108.535 0.62291 109.158 0 109.926 0H127.143C127.912 0 128.535 0.622913 128.535 1.39132V90.324H108.535V1.39131Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.535 16.1897C108.535 15.4212 109.158 14.7983 109.926 14.7983H127.143C127.912 14.7983 128.535 15.4213 128.535 16.1897V90.4353H108.535V16.1897Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.535,
    y: 34.5298,
    width: 20,
    height: 46.862,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.535 43.5732H128.535V90.4353H108.535V43.5732Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.535 1.39131C135.535 0.62291 136.158 0 136.926 0H154.143C154.912 0 155.535 0.622913 155.535 1.39132V90.324H135.535V1.39131Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.535 46.6091C135.535 45.8407 136.158 45.2178 136.926 45.2178H154.143C154.912 45.2178 155.535 45.8407 155.535 46.6091V81.392H135.535V46.6091Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.535 75.6367H155.535V90.4353H135.535V75.6367Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.535 1.39131C162.535 0.62291 163.158 0 163.926 0H181.143C181.912 0 182.535 0.622913 182.535 1.39132V90.324H162.535V1.39131Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.535 53.1862C162.535 52.4178 163.158 51.7949 163.926 51.7949H181.143C181.912 51.7949 182.535 52.4178 182.535 53.1862V90.4355H162.535V53.1862Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.535,
    y: 68.1743,
    width: 20,
    height: 13.2175,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.535 81.4028H182.535V90.4352H162.535V81.4028Z",
    fill: "#FB6C4B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2633_211438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292.333,
    height: 89,
    fill: "white",
    transform: "translate(0.333252)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2633_211438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4842,
    height: 17.4842,
    fill: "white",
    transform: "translate(209.324 59.8267)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2633_211438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 765.223,
    height: 89,
    fill: "white",
    transform: "translate(-461.667)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsAndManagement);
export default __webpack_public_path__ + "static/media/alerts_and_management.4262d9a88951d9e875658e049ab55e57.svg";
export { ForwardRef as ReactComponent };